/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseErrorNotFoundAllOfError
 */
export interface ResponseErrorNotFoundAllOfError {
    /**
     * 
     * @type {string}
     * @memberof ResponseErrorNotFoundAllOfError
     */
    code: ResponseErrorNotFoundAllOfErrorCodeEnum;
}


/**
 * @export
 */
export const ResponseErrorNotFoundAllOfErrorCodeEnum = {
    NotFound: 'not_found'
} as const;
export type ResponseErrorNotFoundAllOfErrorCodeEnum = typeof ResponseErrorNotFoundAllOfErrorCodeEnum[keyof typeof ResponseErrorNotFoundAllOfErrorCodeEnum];


/**
 * Check if a given object implements the ResponseErrorNotFoundAllOfError interface.
 */
export function instanceOfResponseErrorNotFoundAllOfError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ResponseErrorNotFoundAllOfErrorFromJSON(json: any): ResponseErrorNotFoundAllOfError {
    return ResponseErrorNotFoundAllOfErrorFromJSONTyped(json, false);
}

export function ResponseErrorNotFoundAllOfErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorNotFoundAllOfError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ResponseErrorNotFoundAllOfErrorToJSON(value?: ResponseErrorNotFoundAllOfError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

